'use client';

import { useState } from 'react';
import { Send, Check } from 'lucide-react';

export default function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section
      id="contact"
      className="relative py-24 sm:py-32 bg-[#0a0a0f] border-t border-[#D4AF37]/10 overflow-hidden"
    >
      {/* Leather texture background */}
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage: 'url(/images/leather-texture.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="relative max-w-3xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-10 bg-[#D4AF37]" />
            <span className="eyebrow">Prendre Rendez-vous</span>
            <span className="block h-px w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4">
            <span className="text-gold-gradient">Écrivons</span>{' '}
            <span className="text-[#F4E8C1]">l'histoire.</span>
          </h2>
          <p className="text-[#F4E8C1]/65 font-light leading-relaxed">
            Pour une commande sur mesure, une visite privée de l'atelier, ou
            simplement échanger autour d'un projet. Nous vous répondons dans
            les vingt-quatre heures.
          </p>
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-[#12121a]/70 backdrop-blur-sm border border-[#D4AF37]/20 p-7 sm:p-10 space-y-5"
        >
          <div className="grid sm:grid-cols-2 gap-5">
            <Field label="Nom" name="lastname" placeholder="Votre nom" />
            <Field label="Prénom" name="firstname" placeholder="Votre prénom" />
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            <Field
              label="Courriel"
              name="email"
              type="email"
              placeholder="vous@exemple.com"
            />
            <Field
              label="Téléphone"
              name="phone"
              type="tel"
              placeholder="+32 ..."
            />
          </div>

          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">
              Sujet
            </label>
            <select
              name="subject"
              className="w-full bg-[#0a0a0f] border border-[#D4AF37]/25 px-4 py-3 text-sm text-[#F4E8C1] focus:border-[#D4AF37] focus:outline-none transition-colors"
            >
              <option>Commande sur mesure</option>
              <option>Visite privée de l'atelier</option>
              <option>Information produit</option>
              <option>Partenariat & presse</option>
              <option>Autre demande</option>
            </select>
          </div>

          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">
              Message
            </label>
            <textarea
              name="message"
              rows={5}
              required
              placeholder="Décrivez votre projet, votre pièce souhaitée, ou votre disponibilité..."
              className="w-full bg-[#0a0a0f] border border-[#D4AF37]/25 px-4 py-3 text-sm text-[#F4E8C1] placeholder:text-[#F4E8C1]/30 focus:border-[#D4AF37] focus:outline-none transition-colors resize-none"
            />
          </div>

          <button
            type="submit"
            className="w-full inline-flex items-center justify-center gap-3 py-4 bg-gold-gradient text-[#0a0a0f] font-semibold uppercase tracking-[0.2em] text-xs hover:glow-gold-strong transition-all duration-500"
          >
            {sent ? (
              <>
                <Check size={16} />
                Message envoyé — Merci
              </>
            ) : (
              <>
                <Send size={14} />
                Envoyer la demande
              </>
            )}
          </button>

          <p className="text-center text-[10px] text-[#F4E8C1]/40 uppercase tracking-[0.2em] pt-2">
            Vos informations restent strictement confidentielles
          </p>
        </form>
      </div>
    </section>
  );
}

function Field({
  label,
  name,
  type = 'text',
  placeholder,
}: {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
}) {
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">
        {label}
      </label>
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        required
        className="w-full bg-[#0a0a0f] border border-[#D4AF37]/25 px-4 py-3 text-sm text-[#F4E8C1] placeholder:text-[#F4E8C1]/30 focus:border-[#D4AF37] focus:outline-none transition-colors"
      />
    </div>
  );
}
